/* eslint-disable no-useless-escape */

import React from 'react';
import { InjectedFormProps, reduxForm } from 'redux-form';
import _ from 'lodash';

import t from 'utils/translate';
import { FORM_MODEL } from 'admin/constants/common';

export type TwoFACodeFormValues = { code: string };

type Props = {
	className?: string;
	children?: React.ReactNode;
	onSubmit?: (data: TwoFACodeFormValues) => any;
};

const TwoFACodeForm = ({
	className = '',
	onSubmit = _.noop,
	...props
}: Props & InjectedFormProps<TwoFACodeFormValues, Props>) => {
	return (
		<form className={className} onSubmit={props.handleSubmit(onSubmit)}>
			{props.children}
		</form>
	);
};

export default reduxForm<TwoFACodeFormValues, Props>({
	validate: values => {
		const errors: Partial<TwoFACodeFormValues> = {};
		const _t = (label: string) => t(`login.${label}`);

		if (!_.get(values, 'code')) {
			_.set(errors, 'code', _t('code.required'));
		}

		return errors;
	},
	destroyOnUnmount: true,
	form: FORM_MODEL.TWO_FA_CODE,
})(TwoFACodeForm);
